var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    _vm.employee &&
      _vm.employee.id != (_vm.me && _vm.me.id) &&
      _vm.employee.started == '1970-01-01T00:00:00Z' &&
      _vm.role('admin', 'safetyRepresentative') &&
      _vm.employee.isActive
  )?_c('v-btn',{staticClass:"primary accent-4 white--text mr-2 my-1",attrs:{"small":""},on:{"click":_vm.disable}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("\n    warning\n  ")]),_vm._v("\n  "+_vm._s(_vm.$t("profile.assignment.deactivate"))+"\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }